import request from '@/utils/request'

let Shop_introApi = {

  /*商会简介列表*/
  list(data) {
    return request._post('/shop/plus.shop_intro.Index/index', data);
},
listx(data) {
    return request._post('/shop/plus.shop_intro.Index/indexx', data);
},
shopCoreMemberListx(data) {
    return request._post('/shop/plus.shop_intro.Index/shopCoreMemberindexx', data);
},
/*添加商会简介*/
add(data) {
    return request._post('/shop/plus.shop_intro.Index/add', data);
},
/*修改商会简介*/
edit(data) {
    return request._post('/shop/plus.shop_intro.Index/edit', data);
},
/*删除商会简介*/
del(data) {
    return request._post('/shop/plus.shop_intro.Index/del', data);
},
/*商会简介详情*/
detail(data) {
  return request._post('/shop/plus.shop_intro.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.shop_intro.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.shop_intro.Setting/getSetting', data, errorback);
    },
}
export default Shop_introApi;



// WEBPACK FOOTER //
// ./src/api/shop_intro.js